
export const tick = (msMin?: number, msMax?: number) => {
  const duration = msMin && msMax ? Math.random() * (msMax - msMin) + msMin : msMin;
  return new Promise(resolve => setTimeout(resolve, duration));
}
export default tick;

